(function () {
  document.addEventListener("click", function (event) {
    const toggle = event.target.closest("[data-custom-zone-toggle]");
    if (!toggle) return;
    const root = toggle.closest("[data-custom-zone-disclosure]");
    if (!root) return;
    event.preventDefault();
    const panelId = toggle.getAttribute("aria-controls");
    if (!panelId) return;
    const panel = document.getElementById(panelId);
    if (!panel) return;
    const open = root.classList.toggle("is-open");
    toggle.setAttribute("aria-expanded", open ? "true" : "false");
    panel.setAttribute("aria-hidden", open ? "false" : "true");
  });
})();
